import FlightTimeDisplay from "./FlightTimeDisplay";

export { FlightTimeDisplay };
export default FlightTimeDisplay;
